module.exports = __webpack_public_path__ + "android-chrome-192x192.c710eba6.png";